import React, { useState } from "react";
import "../../styles/SearchBar.css";
import Button from "./Button";

interface SearchBarProps {
  searchQuery: string;
  onSearchQueryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;

  title?: string;
  placeholder?: string;
  showTitle?: boolean;
  className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchQueryChange,
  onSearch,

  title = "My URLs",
  placeholder = "Search by name or URL",
  showTitle = true,
  className = "",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`searchbar-header-row ${className}`}>
      {showTitle && <div className="searchbar-title">{title}</div>}

      <button
        type="button"
        className="search-icon-btn"
        onClick={() => setVisible((v) => !v)}
        aria-label="Show search bar"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="magnifier-gradient"
              x1="0"
              y1="0"
              x2="24"
              y2="24"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#200a58" />
              <stop offset="1" stopColor="#200a58" />
            </linearGradient>
          </defs>
          <circle
            cx="11"
            cy="11"
            r="8"
            stroke="url(#magnifier-gradient)"
            strokeWidth="3"
            fill="none"
          />
          <line
            x1="17"
            y1="17"
            x2="21"
            y2="21"
            stroke="url(#magnifier-gradient)"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <div className={`expandable-search-bar${visible ? " visible" : ""}`}>
        <input
          type="text"
          value={searchQuery}
          onChange={onSearchQueryChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSearch();
            }
          }}
          className="expandable-search-input"
          placeholder={placeholder}
        />
        <Button
          onClick={onSearch}
          variant="outline"
          type="button"
          className="search-submit-btn"
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export default SearchBar;
